const CuponServiceIcon = ({ size = 24, fill = '#0000008A' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10V4H2.01V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V20H22V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM13 17.5H11V15.5H13V17.5ZM13 13H11V11H13V13ZM13 8.5H11V6.5H13V8.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default CuponServiceIcon;
